<template>
    <div>
        <Breadcrumbs main="Prescription" title="Insurance Provider"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">


              <div class="col-md-12">
                <div class="card">
                    <div hidden class="card-header">
                      <h5>Zero Configuration</h5>
                      <span>DataTables has most features enabled by default, so all you need to do to use it with your own tables is to call the construction function:<code>$().DataTable();</code>.</span><span>Searching, ordering and paging goodness will be immediately added to the table, as shown in this example.</span>
                    </div>

                    <div class="card-body">
                      <b-row>
                          <b-col md="4">

                              <b-input-group label-cols="" class="datatable-">
                                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                  <b-input-group-append>
                                      <b-button id="default-secondary" variant="secondary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                                  </b-input-group-append>
                              </b-input-group>

                          </b-col>

                          <!-- <b-col md="3">
                            <b-form-group hidden label-cols="4" content-cols="6"  label="Selection" class="mb-0 datatable-select">
                                <b-form-select
                                  id="table-select-mode-select"
                                  v-model="selectMode"
                                  :options="modes"
                                  class="mb-3"
                                ></b-form-select>
                              </b-form-group>
                          </b-col> -->

                          <b-col md="4">
                              <b-form-group label-cols="4" content-cols="4" label="Per page" class="mb-0 datatable-select">
                                  <b-form-select style="width:100px" v-model="perPage" :options="pageOptions"></b-form-select>
                              </b-form-group>
                          </b-col>

                          <b-col md="4">
                            <div class="text-right">
                              <div class="form-group mb-0 mr-0"></div>
                              <a class="btn btn-primary mr-3 mb-2" v-b-modal.insurer >
                                
                                <i class="icon-link"> </i> Add Provider</a
                              >
                              <!-- <a class="btn btn-outline-primary mr-3" v-b-modal.importDrug >
                                <i class="icon-cloud-up"> </i> Import </a
                              > -->
                            </div>

                            <!-- drug form -->
                            <b-modal id="insurer" ref="insurerModal" v-on:hide="resetInsurer()" :title="`${( editInsurer ? 'Edit Provider : '+editInsurer : 'Add Provider ')} `" ok-title="Done" class="theme-modal">

                              <template #modal-header>
                                <h5>{{ editInsurer ? 'Edit Provider : '+editInsurer : 'Add Provider ' }} <b-button v-if="!(editInsurer)" pill size="xs" type="reset" @click="resetInsurer()" variant="outline-danger">Reset</b-button></h5>
                                
                              </template>
                              <!-- {{ drug }} -->
                                <form id="insurerForm" @submit.stop.prevent="submitInsurer" class="p-2 px-3">

                                    <label class="col-form-label" type="text" for="recipient-name">Insurer :</label>
                                    <b-form-input required v-model="insurer.name" placeholder="Insurer's name"></b-form-input>

                                    <div class="row">
                                        <div class="col-sm-7 col-7">
                                          <label class="col-form-label" for="recipient-name">Contact </label>
                                          <b-form-input v-model="insurer.contact" required type="text" placeholder="Contact"></b-form-input>
                                        </div>
                                        <div class="col-sm-5 col-5">
                                          <label class="col-form-label" for="recipient-name">Status:</label>
                                          <b-form-select required v-model="insurer.status" :options="statusOptions"></b-form-select>
                                        </div>
                                    </div>
                                    
                                    <label class="col-form-label" type="text" for="recipient-name">Email :</label>
                                    <b-form-input v-model="insurer.email" placeholder="Email"></b-form-input>

                                    <label class="col-form-label" for="message-text">Address :</label>
                                    <b-form-textarea
                                      id="textarea"
                                      rows="3"
                                      v-model="insurer.address"
                                    ></b-form-textarea>
                                    <br>
                                    <br>
                                    <b-button block  type="submit" variant="primary">Submit</b-button>

                                    <!-- <label class="col-form-label" for="message-text">Message:</label>
                                    <b-form-textarea
                                      id="textarea"
                                      rows="3"
                                    ></b-form-textarea> -->
                                </form>
                            </b-modal>

                            <!-- import patient -->
                            <!-- <b-modal id="importDrug" size="lg" title="Import Drugs" ok-title="Ok" class="theme-modal">
                              <h5>Choose an Excel file</h5>
                              <p>Choose a <b> .csv, .xls, .xlsx </b> format. File should not exceed <b>0.7MB</b>  must contain not more than <b>3000 records</b></p>
                              <p><b>NB::</b> Drug Form : <span v-for="f in formOptions" :key="f.value"> <b> {{ f.value }} ,</b> </span> </p>
                              <br>
                              <h5>Data presentation below</h5>

                              <table class="table ">
                                <thead>
                                  <th>Drug Name</th>
                                  <th>Drug Code</th>
                                  <th>Form</th>
                                  <th>Strength</th>
                                  <th>Pack Size</th>
                                  <th>Description</th>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td class=""> <i>Paracetamol</i></td>
                                    <td> <i>PR546289</i></td>
                                    <td> <i>Tablets</i></td>
                                    <td> <i>400 mg</i></td>
                                    <td> <i>4</i></td>
                                    <td> <i>Pain Reliever</i></td>
                                  </tr>
                                  <tr>
                                    <td class=""> <i>Ibprufen</i></td>
                                    <td> <i>IBP493809</i></td>
                                    <td> <i>Tablets</i></td>
                                    <td> <i>400 mg</i></td>
                                    <td> <i>4</i></td>
                                    <td> <i>For cold and flu</i></td>
                                  </tr>
                                </tbody>
                              </table>
                              <br>
                              <div class="form-group">
                                <h5>Upload Excel file</h5>
                                <vue-dropzone id="singledropzone" :options="singledropzoneOptions" class="dropzone digits" v-on:vdropzone-sending="sendingEvent">                                
                                </vue-dropzone>
                              </div>
                            </b-modal> -->

                            <!-- view patient -->
                            <!-- <b-modal id="viewDrug" ref="viewDrugModal" :title="'View Drug : '+viewDrug.drugname" ok-title="Ok" class="theme-modal">
                              <b-table stacked :items="[viewDrug]">
                                
                                <template #cell(form)="row">
                                    <a class="btn btn-primary btn-xs btn-pill mr-3">
                                      {{ formValids[row.item.form] }}
                                    </a>
                                </template>

                                <template #cell(createdAt)="row">
                                      {{ new Date(row.item.createdAt).toDateString().substr(4) }}
                                </template>

                              </b-table>
                            </b-modal> -->

                          </b-col>
                      </b-row>
                    <!-- {{ selected }} -->
                      <div class="table-responsive datatable-vue">
                        <b-table
                          show-empty
                          ref="selectableTable"
                          :items="items"
                          :fields="tablefields"
                          :select-mode="selectMode"
                          :sort-by.sync="sortBy"
                          selectable
                          :filter="filter"
                          :current-page="currentPage"
                          :per-page="perPage"
                          @filtered="onFiltered"
                          @row-selected="onRowSelected"
                        >
                          <template #cell(action)="row">
                            <!-- <b-button size="sm" @click="row.toggleDetails" class="mr-2 ">
                              {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                            </b-button> -->
                            <b-dropdown text="more" size="sm" left class="mx-2" menu-class="dropdown-content" variant="primary">
                              <b-dropdown-item @click="edit(row.item)">Edit</b-dropdown-item>
                              <b-dropdown-divider></b-dropdown-divider>
                              <b-dropdown-item @click="del(row.item.name)">Delete</b-dropdown-item>
                          </b-dropdown>
                          </template>

                          <template #cell(no)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a
                              > -->
                              {{ row.index + 1 }}
                          </template>

                          <template #cell(active)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a
                              > -->
                              <a @click="status(row.item)" :class="`btn ${ (row.item.active ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                {{ (row.item.active ? 'acive' : 'inactive') }}
                              </a>
                          </template>

                          <template #cell(email)="row">
                              <a style="font-weight:500" :href="`mailto:${row.item.email}`" class="txt-primary">
                                {{ row.item.email }}
                             </a>
                          </template>

                          <template #cell(contact)="row">

                            <a style="font-weight:500" :href="`tel:${row.item.contact}`" class="txt-primary">
                                {{ row.item.contact }}
                              </a>
                          </template>

                          <template #cell(createdAt)="row">
                                {{ new Date(row.item.createdAt).toDateString().substr(4) }}
                          </template>
                        </b-table>
                        
                      </div>

                      <p>{{ items.length }} items </p>

                      <b-col md="6" class="my-1">
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          class="my-0"
                        ></b-pagination>
                      </b-col>
                      


                    </div>

                </div>
              </div>

            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
// import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'

export default {
  data(){
    return{
      singledropzoneOptions:{
          url:"http://localhost:8080",
          thumbnailWidth: 150,
          maxFiles:1,
          maxFilesize: 0.7,
          addRemoveLinks: true,
          dictDefaultMessage:"<i class='icon-cloud-up'></i><h6>Drop file here or click to upload.</h6><span>( Selected file is <strong>uploaded</strong> imediately after selection.)</span>"
      },
      editInsurer: false,
      insurer: {
        name: '',
        contact: '',
        status: '',
        email: '',
        address: '',
      },
      viewInsurer: {},
      statusOptions: [
          { value: '', text: 'Select status' },
          { value:true, text: 'active' },
          { value:false, text: 'inactive' }
      ],
      tablefields: [
        { key: 'no', label: 'No', sortable: true, },
        { key: 'name', label: 'Insurer', sortable: true, },
        { key: 'contact', label: 'Contact', sortable: false, },
        { key: 'active', label: 'Status', sortable: true, },
        { key: 'email', label: 'Email', sortable: false, },
        { key: 'address', label: 'Address', sortable: false, },
        { key: 'createdAt', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],

      items: [
      ],
      modes: ['multi', 'single', 'range'],
      filter: null,
      sortBy: 'name',
      selectMode: 'multi',
      selected: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 25, 50, 100],
    }
  },
  components: {
    // vueDropzone: vue2Dropzone
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  created() {
    // watch and fetch
    this.$watch(
      () => this.$route.$params,
      () => {
        this.fetchData()
      },
      { immediate: true }

    )

  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  methods: {
    fetchData() {
      axios.get('/insurance')
        .then(response=>{
          //
          this.items = response.data
        })
        .catch( e => {
          this.$swal({
            title:"Failed!",
            text: e,
            type:'error'
          });
        })
    },
    resetInsurer() {
      this.editInsurer = false
      this.insurer.name = ''
      this.insurer.contact = ''
      this.insurer.status = ''
      this.insurer.email = ''
      this.insurer.address = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    sendingEvent (file, xhr, formData) {
        formData.append('paramName', 'some value or other');
    },
    submitInsurer(){

      let url
      let method

      if (this.editInsurer) {
        url = '/insurance/'+this.editInsurer
        method = axios.patch;
      } else {
        url = '/insurance'
        method = axios.post;
      }

      method(url, this.insurer)
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });
        //
        this.$refs.insurerModal.hide()
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

      
    },
    edit(data) {
      // modal
      this.$refs.insurerModal.show()
      this.editInsurer = data.name
      // form
      this.insurer.name = data.name.trim()
      this.insurer.contact = data.contact
      this.insurer.status = data.active
      this.insurer.email = data.email
      this.insurer.address = data.address
    },
    status(data) {
      //
      axios.post('/insurance/status', { name: data.name, status: data.active })
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    del(name) {
      this.$swal({
				text:`Are you sure you want to delete '${name}'?`,
				showCancelButton: true,
				confirmButtonText: 'Yes',
        type:'error'
			}).then((result)=>{

        if(result.value){

          axios.delete('/insurance/'+name)
            .then(response=>{
              //
              this.$swal({
                title:"Good job!",
                text: response.data,
                type:'success'
              });
              //
            //   this.$refs.insurerModal.hide()
              //
              this.fetchData()
            })
            .catch( e => {
              this.$swal({
                title:"Failed!",
                text: e.message,
                type:'error'
              });
          })
        }
     });
    }
  }
}
</script>
<style scoped>
/* #patientForm .form-control {
 font-size: inherit;
} */

.table tr > td {
  color: rgba(43,43,43,.54);
}
</style>